import Vue from 'vue'
const directives = require.context('../directive', false, /directive.(\S{1,}).js$/)

//名称需要  directive.XXX.js
directives.keys().map(path => {
  let list = path.split(".")
  const o = directives(path).default || directives(path);
  Vue.directive(list[2], o)
});


// WEBPACK FOOTER //
// ./src/directive/index.js